<template>
  <!--<router-link :class="$style.container" :to="`${base}/${source.email}`">-->
  <div :class="$style.container" @click="setSelectedUser(source)">
    <div :class="$style.header">
      <TextComponent :class="$style.title" type="heading4" color="teal" as="h2">
        {{ `${source.firstName} ${source.lastName}${discord.suffix ? ` (${discord.suffix})` : ''}` }}
      </TextComponent>
      <TextComponent type="body2" as="span">
        <strong>
          {{ discord.discordID === undefined ? 'No activity' : 'Checked In' }}
        </strong>
      </TextComponent>
    </div>
    <Stack direction="column" spacing="tad">
      <TextComponent :class="$style.text" type="body3">
        <Icon :class="$style.icon" name="paper-plane" />
        {{ source.email }}
      </TextComponent>
      <TextComponent :class="$style.text" type="body3">
        Discord ID: {{ discord.discordID || 'N/A' }} |
        Discord Username: {{ discord.username || 'N/A' }}
      </TextComponent>
      <TextComponent :class="$style.text" type="body3">
        Verify Time: {{ discord.verifyTime ? new Date(discord.verifyTime).toString() : 'N/A' }}
      </TextComponent>
      <TextComponent :class="$style.text" type="body3">
        Roles: {{ (discord.additionalRoles || []).join(', ') }}
      </TextComponent>
    </Stack>
  </div>
  <!--</router-link>-->
</template>

<script>
  import Stack from '@hackthe6ix/vue-ui/Stack';
  import Text from '@hackthe6ix/vue-ui/Text';
  import Icon from 'vue-awesome/components/Icon';
  import 'vue-awesome/icons/hashtag';
  import 'vue-awesome/icons/paper-plane';

  export default {
  name: 'DiscordCard',
  components: {
    TextComponent: Text,
    Stack,
    Icon,
  },
  computed: {
    discord() {
      return this.source.discord || {};
    }
  },
  props: {
    index: Number,
    source: Object,
    setSelectedUser: Function
  }
};
</script>

<style lang="scss" module src="./DiscordCard.module.scss" />
